import axios from "axios";
import { toast } from "react-toastify";
export const editClub = async (api, data, token) => {
  // try {
  const formData = new FormData();

  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("club", data.club);
  formData.append("category", data.category);
  formData.append("sub_category", data.subCategory);
  formData.append("from_uk", data.from_uk);
  if (data?.video && Array.isArray(data.video)) {
    data.video.forEach((video) => {
      if (typeof video == "object") {
        formData.append("videoFile", video);
      }
    });
  }
  formData.append("region", data.region);
  formData.append("user_id", data.user_id);
  formData.append("visibility", data.visibility);
  if (data?.image && typeof data.image == "object") {
    formData.append("club_img", data.image);
  } else {
  }

  if (data?.invite_users) {
    data.invite_users
      .filter((user) => user.phone_number)
      .map((user) => {
        formData.append("invite_users[]", user.phone_number);
      });
  }

  if (api == "/clubs/editClub") {
    formData.append("club_id", data.club_id);
    if (data?.delete_videos.length > 0) {
      data.delete_videos.map((id) => {
        formData.append("delete_videos[]", id);
      });
    }
    if (data?.removedUsers?.length > 0) {
      data.removedUsers?.map((mem) => {
        formData.append("remove_users[]", mem.id);
      });
    }
  }

  formData.append("video_meta", JSON.stringify(data.video_meta));
  formData.append("editedVideo", JSON.stringify(data.editedVideoMeta));

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL_USER}${api}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
  // } catch (error) {
  //   if (error.response) {
  //     "";
  //     const msg = error?.response?.data?.rejectedFiles?.reduce(
  //       (m, c, _) => (m += `\n${c?.originalname}: ${c?.reason}`),
  //       "",
  //     );

  //     toast.error(msg || error.message, { autoClose: false });
  //   } else {
  //     toast.error(error.message);
  //   }
  // }
};
